import React, { useEffect, useState, useContext } from "react";
import {
  Modal,
  Menu,
  MenuItem,
  Dialog,
  DialogContent,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormModal from "./offerModal";
import { RootState } from "../redux/store/store";
import { useSelector } from "react-redux";
import {
  deleteStudentOfferService,
  updateStudentOfferService,
  sendOfferService,
  validatePromoCode as validatePromoCodeService,
  archiveStudentOfferService,
} from "../services/student-offer";
import {
  deleteTeacherOfferService,
  updateTeacherOfferService,
  archiveTeacherOfferService,
} from "../services/teacher-offer";
import { useLocation } from "react-router-dom";
import OfferStudentModal from "./offer-student-modal";
import { getSpecialPromoCode } from "../services/promo-code-service";
import { SnackbarContext } from "../config/hooks/use-toast";
import "./cards.css";

// @ts-ignore
const OfferCard = ({ offer, onclick, onUpdateOffer, onDeleteOffer, onSubscribed = () => { } }) => {
  const location = useLocation();
  const isOfferStudent = location.pathname.includes("offer-student");
  const snackbarContext = useContext(SnackbarContext);

  const userData = useSelector((state: RootState) => state?.user?.userData);
  const role = userData?.role?.name;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const teacherPriceFallback = Number(offer.monthlyPrice) || 0;
  const teacherPriceRaw = Number(offer.price);
  // Use explicit price when provided (>=0); otherwise fallback to legacy monthlyPrice
  const teacherPrice = teacherPriceRaw >= 0
    ? teacherPriceRaw
    : Math.max(0, teacherPriceFallback);
  const teacherPeriodMonths = Math.max(1, Number(offer.monthlyPeriod) || 1);

  const isPriceZeroOrEmpty = (p: any) => {
    if (p === null || p === undefined || p === '') return true;
    const n = parseFloat(String(p));
    return isNaN(n) || n === 0;
  };
  const isFreeOffer = isOfferStudent
    ? ([offer.monthlyPrice, offer.trimesterPrice, offer.semesterPrice, offer.yearlyPrice].every(isPriceZeroOrEmpty))
    : teacherPrice === 0;

  const isAcceptedRequestStillActive = (() => {
    if (offer?.status !== "ACCEPTED") return false;
    if (!offer?.requestEndDate) return true;
    const endDateMs = new Date(offer.requestEndDate).getTime();
    return !Number.isNaN(endDateMs) && endDateMs > Date.now();
  })();

  const isCurrentlySubscribed = Boolean(offer?.subscribed) || isAcceptedRequestStillActive;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const benefitsArray = offer?.offerDetails?.split(/\s*\n\s*/)?.filter(Boolean) || [];

  const handleAction = (formData: any) => {
    if (isOfferStudent) {
      updateStudentOfferService(offer.id, formData)
        .then((updatedOffer) => {
          onUpdateOffer(updatedOffer.data);
          handleClose();
          handleCloseEditModal();
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succes",
              "Offre Modifier avec succée",
              "success",
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      updateTeacherOfferService(offer.id, formData)
        .then((updatedOffer) => {
          onUpdateOffer(updatedOffer.data);
          handleClose();
          handleCloseEditModal();
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succes",
              "Offre Ajouter avec succée",
              "success",
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleOpenEditModal = () => setIsEditModalOpen(true);
  const handleCloseEditModal = () => setIsEditModalOpen(false);
  const [open, setOpen] = React.useState(false);

  const handleClickAlert = () => {
    handleClose();
    console.log(offer);
    setOpen(true);
  };

  const handleCloseAlert = () => {
    setOpen(false);
  };
  const handleDelete = () => {
    if (isOfferStudent) {
      deleteStudentOfferService(offer.id)
        .then((res) => {
          setOpen(false);
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succes",
              "Offre supprimer avec succée",
              "success",
            );
          }
          handleClose();
          onDeleteOffer();
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      deleteTeacherOfferService(offer.id)
        .then((res) => {
          setOpen(false);
          handleClose();
          onDeleteOffer();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const handleArchive = () => {
    const archiveService = isOfferStudent ? archiveStudentOfferService : archiveTeacherOfferService;
    archiveService(offer.id)
      .then(() => {
        if (snackbarContext) {
          snackbarContext.showMessage(
            "Succès",
            offer.archived ? "Offre désarchivée avec succès" : "Offre archivée avec succès",
            "success"
          );
        }
        handleClose();
        onUpdateOffer({ ...offer, archived: !offer.archived });
      })
      .catch((e) => {
        console.log(e);
        if (snackbarContext) {
          snackbarContext.showMessage("Erreur", "Une erreur est survenue", "error");
        }
      });
  };

  // Find the first available period with a price > 0 (students only)
  const availablePeriods = isOfferStudent
    ? [
      { key: 'MONTHLY', label: 'الشهري', price: offer.monthlyPrice },
      { key: 'TRIMESTER', label: 'الثلاثي', price: offer.trimesterPrice },
      { key: 'SEMESTER', label: 'السداسي', price: offer.semesterPrice },
      { key: 'YEARLY', label: 'السنوي', price: offer.yearlyPrice }
    ].filter(({ price }) => Number(price) > 0)
    : [];

  const defaultPeriod = availablePeriods.length > 0 ? availablePeriods[0].key : 'MONTHLY';
  const [selectedPeriod, setSelectedPeriod] = useState<'MONTHLY' | 'TRIMESTER' | 'SEMESTER' | 'YEARLY'>(defaultPeriod as any);
  const [subjectCount, setSubjectCount] = useState(1);
  const [paymentFile, setPaymentFile] = useState<File | null>(null);
  const [promoCode, setPromoCode] = useState("");
  const [promoError, setPromoError] = useState("");
  const [discountedTotal, setDiscountedTotal] = useState<number | null>(null);
  const [discountPercent, setDiscountPercent] = useState<number | null>(null);
  const [promoLoading, setPromoLoading] = useState(false);
  const [isSpecialPromoActive, setIsSpecialPromoActive] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const hasFixedSubjects = Array.isArray(offer.subjectIds) && offer.subjectIds.length > 0;
  const effectiveSubjectCount = hasFixedSubjects ? offer.subjectIds.length : subjectCount;

  const getPriceForPeriod = () => {
    if (!isOfferStudent) return teacherPrice;
    switch (selectedPeriod) {
      case 'MONTHLY':
        return offer.monthlyPrice;
      case 'TRIMESTER':
        return offer.trimesterPrice;
      case 'SEMESTER':
        return offer.semesterPrice;
      case 'YEARLY':
        return offer.yearlyPrice;
      default:
        return offer.monthlyPrice;
    }
  };

  // Helper to check if price is valid (not null/undefined and not NaN)
  const isValidPrice = (price: any) => price !== undefined && price !== null && !isNaN(price) && price !== '';

  const getSubjectMultiplier = () => {
    if (!isOfferStudent) return 1;
    // Special multipliers for YEARLY period
    if (selectedPeriod === 'YEARLY') {
      switch (effectiveSubjectCount) {
        case 1: return 1;
        case 2: return 1.5;
        case 3: return 2.25;
        case 4: return 3;
        default: return effectiveSubjectCount;
      }
    }
    // For other periods, 4 subjects = 3.5x
    if (effectiveSubjectCount === 4) return 3.5;
    return effectiveSubjectCount;
  };

  const getBaseTotalPrice = () => {
    const periodPrice = Number(getPriceForPeriod()) || 0;
    return Math.floor(periodPrice * Number(getSubjectMultiplier()));
  };

  const getReferencePrice = () => {
    if (!isOfferStudent) {
      return Math.floor(teacherPrice * teacherPeriodMonths);
    }
    const monthCount =
      selectedPeriod === "MONTHLY"
        ? 1
        : selectedPeriod === "TRIMESTER"
          ? 3
          : selectedPeriod === "SEMESTER"
            ? 6
            : 12;
    const monthlyPrice = Number(offer.monthlyPrice) || 0;
    return Math.floor(monthlyPrice * monthCount * Number(getSubjectMultiplier()));
  };

  const getCurrentPrice = () => discountedTotal ?? getBaseTotalPrice();

  const getTotalPrice = () => {
    if (discountedTotal !== null) return discountedTotal;
    return getBaseTotalPrice();
  };

  useEffect(() => {
    if (role === "ROLE_STUDENT" && userData?.id) {
      getSpecialPromoCode(userData.id)
        .then((data) => {
          const code = (data as any)?.code;
          const discount = (data as any)?.discountPercentage || 50;
          if (code) {
            if (!promoCode || promoCode === code) {
              setIsSpecialPromoActive(true);
              setPromoCode(code);
              const baseTotal = getBaseTotalPrice();
              setDiscountPercent(discount);
              setDiscountedTotal(Math.max(0, Math.round(baseTotal - (baseTotal * (discount / 100)))));
            }
          }
        })
        .catch(() => {
          // Ignore missing special code
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, userData?.id]);

  useEffect(() => {
    if (isSpecialPromoActive && selectedPeriod === 'YEARLY') {
      setSelectedPeriod('MONTHLY');
    }
  }, [isSpecialPromoActive, selectedPeriod]);

  useEffect(() => {
    if (hasFixedSubjects) {
      setSubjectCount(offer.subjectIds.length);
    }
  }, [hasFixedSubjects, offer.subjectIds]);

  // Recalculate discounts when the base price changes (period/subjects)
  useEffect(() => {
    if (isOfferStudent && discountPercent !== null) {
      const baseTotal = getBaseTotalPrice();
      const discount = baseTotal * (discountPercent / 100);
      setDiscountedTotal(Math.max(0, Math.round(baseTotal - discount)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    discountPercent,
    selectedPeriod,
    subjectCount,
    offer.monthlyPrice,
    offer.trimesterPrice,
    offer.semesterPrice,
    offer.yearlyPrice,
  ]);

  return (
    <div
      className={`group relative flex flex-col w-full max-w-[380px] min-h-[600px] bg-white rounded-[3rem] border border-gray-100 shadow-[0_20px_50px_rgba(0,0,0,0.02)] transition-all duration-700 hover:shadow-[0_40px_90px_rgba(0,0,0,0.12)] hover:-translate-y-3 overflow-hidden ${isCurrentlySubscribed ? 'ring-2 ring-primary ring-offset-4' : ''}`}
    >
      {/* Decorative background blur */}
      <div className="absolute top-0 right-0 w-32 h-32 -mt-16 -mr-16 rounded-full pointer-events-none bg-primary/5 blur-3xl"></div>

      {/* Admin Actions */}
      {role === "ROLE_ADMIN" && (
        <div className="absolute z-30 top-6 right-6">
          <button
            onClick={handleClick}
            className="flex items-center justify-center w-10 h-10 transition-all duration-300 border border-white shadow-sm outline-none rounded-2xl bg-white/80 backdrop-blur-md text-text/40 hover:text-primary"
          >
            <MoreVertIcon className="text-xl" />
          </button>
        </div>
      )}

      {/* Hero Image Section */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={offer?.imageUrl || "https://via.placeholder.com/300x208?text=Offre"}
          alt={offer.title}
          className="object-cover w-full h-full transition-transform duration-1000 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent"></div>

        {/* Status Badges */}
        {offer.status === 'PENDING' ? (
          <div className="absolute top-6 left-6 z-20 px-4 py-2 bg-amber-500 text-white text-[10px] font-black uppercase tracking-[0.2em] rounded-xl shadow-xl shadow-amber-500/20 flex items-center gap-2">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <span>En Attente</span>
          </div>
        ) : isCurrentlySubscribed ? (
          <div className="absolute top-6 left-6 z-20 px-4 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-[0.2em] rounded-xl shadow-xl shadow-primary/20 flex items-center gap-2">
            <CheckCircleIcon className="text-[10px]" />
            <span>Souscrit</span>
          </div>
        ) : isFreeOffer && (
          <div className="absolute top-6 left-6 z-20 px-4 py-2 bg-blue-500 text-white text-[10px] font-black uppercase tracking-[0.2em] rounded-xl shadow-xl shadow-blue-500/20">
            Gratuit
          </div>
        )}
        {offer.archived && (
          <div className="absolute top-6 right-16 z-20 px-4 py-2 bg-gray-500 text-white text-[10px] font-black uppercase tracking-[0.2em] rounded-xl shadow-xl shadow-gray-500/20">
            Archivée
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="flex flex-col flex-1 p-8 pt-0">
        <div className="mb-6 text-center">
          <h2 className="mb-2 text-2xl font-black tracking-tight uppercase text-title line-clamp-1">{offer.title}</h2>
          {offer.subTitle && (
            <p className="text-[10px] font-bold text-primary uppercase tracking-[0.2em]">{offer.subTitle}</p>
          )}
        </div>

        {/* Pricing Area */}
        <div className="flex flex-col items-center justify-center mb-8 p-6 rounded-[2.5rem] bg-gray-50/50 border border-gray-100 relative overflow-hidden group/price">
          <div className="absolute w-24 h-24 transition-all duration-500 rounded-full -right-4 -bottom-4 bg-primary/5 blur-2xl group-hover/price:bg-primary/10"></div>

          {isFreeOffer ? (
            <div className="flex flex-col items-center gap-2">
              <span className="text-5xl font-black tracking-tighter text-emerald-500">GRATUIT</span>
              <span className="text-[10px] font-black px-3 py-1 bg-emerald-50 text-emerald-600 rounded-xl uppercase tracking-widest border border-emerald-100">Accès inclus</span>
              {Number(offer.freeDurationDays) > 0 && (
                <span className="text-[10px] font-black px-3 py-1 bg-white text-emerald-700 rounded-xl uppercase tracking-widest border border-emerald-100">
                  {offer.freeDurationDays} Jours
                </span>
              )}
            </div>
          ) : (
            <>
              <div className="flex items-baseline gap-2">
                <span className="text-5xl font-black tracking-tighter text-title">
                  {isValidPrice(getCurrentPrice()) ? getCurrentPrice() : '--'}
                </span>
                <span className="text-lg font-black tracking-widest uppercase text-primary">DT</span>
              </div>

              {(() => {
                const reference = getReferencePrice();
                const current = getCurrentPrice();
                return isOfferStudent && !isFreeOffer && isValidPrice(reference) && current < reference;
              })() && (
                  <div className="flex items-center gap-2 mt-2">
                    <span className="text-xs font-bold line-through text-text/30">{getReferencePrice()} DT</span>
                    <span className="text-[10px] font-black px-2 py-0.5 bg-red-50 text-red-500 rounded-lg uppercase tracking-wider">-{Math.round((1 - getCurrentPrice() / getReferencePrice()) * 100)}%</span>
                  </div>
                )}
            </>
          )}
        </div>

        {/* Dynamic Controls (Only for students and paid offers) */}
        {isOfferStudent && !isFreeOffer && (
          <div className="mb-8 space-y-6">
            {/* Period Toggles */}
            <div className="flex flex-wrap gap-2 p-1.5 bg-white rounded-[1.8rem] border border-gray-100 shadow-sm">
              {availablePeriods.map(({ key, label }) => {
                const active = selectedPeriod === key;
                const disabled = isSpecialPromoActive && key === 'YEARLY';
                return (
                  <button
                    key={key}
                    onClick={() => !disabled && setSelectedPeriod(key as any)}
                    className={`flex-1 py-2.5 px-2 rounded-2xl text-[10px] font-black uppercase tracking-wider transition-all duration-300 ${active ? 'bg-primary text-white shadow-lg shadow-primary/20' : 'text-text/40 hover:text-primary hover:bg-primary/5'} ${disabled ? 'opacity-30 cursor-not-allowed' : ''}`}
                  >
                    {label === 'الشهري' ? 'Mois' : label === 'الثلاثي' ? 'Trim' : label === 'السداسي' ? 'Sem' : 'Année'}
                  </button>
                );
              })}
            </div>

            {/* Subject Count */}
            {!offer.allSubjects && !hasFixedSubjects && (
              <div className="flex items-center justify-between gap-1 p-1 border border-gray-100 bg-gray-50/50 rounded-2xl">
                {Array.from({ length: offer.subjectCount || 4 }, (_, i) => i + 1).map((count) => (
                  <button
                    key={count}
                    onClick={() => setSubjectCount(count)}
                    className={`flex-1 py-3 px-2 rounded-xl text-[10px] font-black transition-all duration-300 ${subjectCount === count ? 'bg-white text-primary shadow-sm' : 'text-text/30 hover:text-text/60'}`}
                  >
                    {count} {count === 1 ? 'Mat.' : 'Mat.'}
                  </button>
                ))}
              </div>
            )}
            {!offer.allSubjects && hasFixedSubjects && (
              <div className="px-4 py-3 border border-primary/10 bg-primary/5 rounded-2xl text-[10px] font-black uppercase tracking-[0.2em] text-primary text-center">
                Pack fixe: {offer.subjectIds.length} matière{offer.subjectIds.length > 1 ? 's' : ''}
              </div>
            )}
          </div>
        )}

        {/* Benefits List */}
        <div className="space-y-3 mb-8 flex-1 overflow-y-auto max-h-[140px] no-scrollbar pr-2">
          {benefitsArray.length === 0 ? (
            <p className="text-xs italic text-center text-text/30">Aucun détail disponible</p>
          ) : (
            benefitsArray.map((benefit: any, index: React.Key) => (
              <div key={index} className="flex items-start gap-3">
                <div className="flex items-center justify-center flex-shrink-0 w-4 h-4 mt-1 rounded-full bg-primary/10">
                  <CheckCircleIcon className="text-[10px] text-primary" />
                </div>
                <span className="text-xs font-semibold text-text/70 line-clamp-2">{benefit}</span>
              </div>
            ))
          )}
        </div>

        {/* Subscription States - Properly prioritised */}
        {offer.status === 'PENDING' ? (
          <div className="w-full py-5 bg-amber-500/10 text-amber-600 font-black text-[11px] uppercase tracking-[0.3em] text-center rounded-[1.8rem] border border-amber-500/20 mt-auto flex items-center justify-center gap-2">
            <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse"></div>
            En Attente de Validation
          </div>
        ) : isCurrentlySubscribed ? (
          <div className="w-full py-5 bg-emerald-500/10 text-emerald-600 font-black text-[11px] uppercase tracking-[0.3em] text-center rounded-[1.8rem] border border-emerald-500/20 mt-auto flex items-center justify-center gap-2">
            <CheckCircleIcon className="text-sm" />
            Déjà Abonné
          </div>
        ) : (role !== "ROLE_ADMIN") ? (
          <button
            onClick={async () => {
              if (isOfferStudent) {
                if (isFreeOffer) {
                  // Free student offer: submit directly without payment modal
                  if (submitLoading) return;
                  setSubmitLoading(true);
                  try {
                    const fd = new FormData();
                    fd.append("selectedPeriod", "MONTHLY");
                    fd.append("requestedSubjectsCount", String(hasFixedSubjects ? offer.subjectIds.length : 1));
                    await sendOfferService(offer.id, fd);
                    snackbarContext?.showMessage("Succès", "Inscription gratuite confirmée avec succès", "success");
                    if (onSubscribed) onSubscribed();
                  } catch {
                    snackbarContext?.showMessage("Erreur", "Une erreur est survenue lors de l'inscription", "error");
                  } finally {
                    setSubmitLoading(false);
                  }
                } else {
                  handleOpenModal();
                }
              } else {
                onclick();
              }
            }}
            disabled={submitLoading}
            className={`w-full py-5 font-black text-[11px] uppercase tracking-[0.3em] text-center rounded-[1.8rem] transition-all duration-500 shadow-2xl mt-auto ${submitLoading
                ? 'bg-gray-200 text-text/30 cursor-not-allowed shadow-none'
                : 'bg-[#05322B] text-white hover:bg-primary shadow-black/20 hover:-translate-y-1'
              }`}
          >
            {submitLoading && isFreeOffer ? 'Inscription...' : isFreeOffer ? 'Rejoindre Gratuitement' : 'S\'abonner Maintenant'}
          </button>
        ) : null}
      </div>

      {/* Admin Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          className: "shadow-2xl border border-gray-100 rounded-2xl",
          style: { minWidth: '150px' }
        }}
      >
        <MenuItem onClick={() => { handleClose(); handleOpenEditModal(); }} className="py-3 text-sm font-bold text-title hover:bg-primary/5">
          Modifier
        </MenuItem>
        <MenuItem onClick={handleArchive} className="py-3 text-sm font-bold text-title hover:bg-primary/5">
          {offer.archived ? "Désarchiver" : "Archiver"}
        </MenuItem>
        <MenuItem onClick={handleClickAlert} className="py-3 text-sm font-bold text-red-500 hover:bg-red-50">
          Supprimer
        </MenuItem>
      </Menu>

      <AnimatePresence>
        {open && (
          <Modal
            open={open}
            onClose={handleCloseAlert}
            className="flex items-center justify-center p-4 backdrop-blur-xl bg-title/40"
            closeAfterTransition
          >
            <motion.div
              className="w-full max-w-[450px] bg-white rounded-[3rem] p-10 shadow-3xl text-center outline-none border border-white/20"
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
            >
              <div className="w-24 h-24 rounded-[2.5rem] bg-rose-50 text-rose-500 flex items-center justify-center text-4xl mx-auto mb-8 border border-rose-100 shadow-sm relative">
                <div className="absolute inset-0 bg-rose-400/20 rounded-[2.5rem] animate-ping opacity-50"></div>
                <FontAwesomeIcon icon={faTrashCan} className="relative z-10" />
              </div>

              <h3 className="mb-4 text-2xl font-black tracking-tight uppercase text-title">
                Supprimer <span className="text-rose-500">l'Offre</span>
              </h3>

              <p className="px-4 mb-10 text-sm font-medium leading-relaxed text-text/60">
                Êtes-vous sûr de vouloir supprimer cette offre <span className="text-[#05322B] font-black">{offer.title}</span> ? cette action est irréversible.
              </p>

              <div className="flex gap-4">
                <button
                  className="flex-1 h-16 bg-slate-50 text-text/40 font-black text-[11px] uppercase tracking-widest rounded-2xl hover:bg-slate-100 transition-all duration-300 outline-none cursor-pointer"
                  onClick={handleCloseAlert}
                >
                  Annuler
                </button>
                <button
                  className="flex-1 h-16 bg-rose-500 text-white font-black text-[11px] uppercase tracking-widest rounded-2xl shadow-xl shadow-rose-500/20 hover:bg-rose-600 hover:-translate-y-1 transition-all duration-300 outline-none cursor-pointer"
                  onClick={handleDelete}
                >
                  Supprimer
                </button>
              </div>
            </motion.div>
          </Modal>
        )}
      </AnimatePresence>

      {/* Student/Admin Modals */}
      {isOfferStudent ? (
        <OfferStudentModal
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          initialData={{ image: offer.imageUrl, ...offer }}
          modalTitle="Modifier l'offre"
          buttonText="Mettre à jour"
          onButtonClick={handleAction}
        />
      ) : (
        <FormModal
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          initialData={{ image: offer.imageUrl, ...offer }}
          modalTitle="Modifier l'offre"
          buttonText="Mettre à jour"
          onButtonClick={handleAction}
        />
      )}

      {/* Student Subscription Modal */}
      <Dialog
        open={isModalOpen}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          className: "rounded-[3rem] overflow-hidden shadow-[0_50px_100px_rgba(0,0,0,0.4)]"
        }}
      >
        <div className="sticky top-0 z-20 flex flex-col items-center px-10 pt-8 pb-4 border-b bg-white/90 backdrop-blur-md border-gray-50">
          <h2 className="text-2xl font-black tracking-tight uppercase text-title">Demande d'abonnement</h2>
          <p className="text-[9px] font-bold text-primary uppercase tracking-[0.4em] mt-2">Détails de la commande</p>
          <button onClick={handleCloseModal} className="absolute flex items-center justify-center w-10 h-10 transition-all rounded-full top-6 right-8 bg-gray-50 text-text/30 hover:text-red-500">
            <span className="text-2xl font-light">&times;</span>
          </button>
        </div>

        <DialogContent className="p-8 md:p-12 no-scrollbar">
          {/* Period Grid */}
          <div className="mb-10">
            <h3 className="text-[10px] font-black text-title uppercase tracking-widest mb-4 ml-2">Sélectionner la période</h3>
            <div className="flex flex-wrap w-full gap-3">
              {[...availablePeriods].map(({ key, label }) => {
                const active = selectedPeriod === key;
                const disabled = isSpecialPromoActive && key === 'YEARLY';
                return (
                  <button
                    key={key}
                    onClick={() => !disabled && setSelectedPeriod(key as any)}
                    className={`flex-1 min-w-[80px] py-4 rounded-2xl text-[10px] font-black uppercase tracking-wider transition-all shadow-sm ${active ? 'bg-primary text-white shadow-primary/20 ring-2 ring-primary ring-offset-2' : 'bg-gray-50 text-text/40 hover:bg-gray-100'} ${disabled ? 'opacity-30 cursor-not-allowed' : ''}`}
                  >
                    {label === 'الشهري' ? 'Mois' : label === 'الثلاثي' ? 'Trim' : label === 'السداسي' ? 'Sem' : 'Année'}
                  </button>
                )
              })}
            </div>
          </div>

          {/* Subject Count */}
          {!isFreeOffer && !offer.allSubjects && !hasFixedSubjects && (
            <div className="mb-10">
              <h3 className="text-[10px] font-black text-title uppercase tracking-widest mb-4 ml-2">Nombre de matières</h3>
              <div className="flex flex-wrap w-full gap-3">
                {Array.from({ length: offer.subjectCount || 4 }, (_, i) => i + 1).map(count => (
                  <button
                    key={count}
                    onClick={() => setSubjectCount(count)}
                    className={`flex-1 min-w-[60px] py-4 rounded-2xl text-[10px] font-black transition-all ${subjectCount === count ? 'bg-title text-white shadow-xl shadow-title/20 ring-2 ring-title ring-offset-2' : 'bg-gray-50 text-text/40'}`}
                  >
                    {count} {count === 1 ? 'Matière' : 'Matières'}
                  </button>
                ))}
              </div>
            </div>
          )}
          {!isFreeOffer && !offer.allSubjects && hasFixedSubjects && (
            <div className="mb-10 rounded-[2rem] border border-primary/10 bg-primary/5 px-6 py-5 text-center">
              <h3 className="text-[10px] font-black text-title uppercase tracking-widest">Pack de matières</h3>
              <p className="mt-2 text-[11px] font-bold text-primary">Cette offre inclut automatiquement {offer.subjectIds.length} matière{offer.subjectIds.length > 1 ? 's' : ''}.</p>
            </div>
          )}

          {/* Summary Glass Card */}
          <div className="p-8 rounded-[2rem] bg-gray-50 border border-gray-100 mb-10 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 rounded-full bg-primary/5 blur-3xl"></div>
            <div className="relative z-10 space-y-4">
              <div className="flex items-center justify-between text-xs font-bold tracking-wider uppercase text-text/40">
                <span>Base ({offer.allSubjects ? 'Pack' : `${effectiveSubjectCount} mat.`})</span>
                <span>{getPriceForPeriod()} DT</span>
              </div>
              <div className="h-px bg-gray-200"></div>
              <div className="flex items-end justify-between">
                <span className="text-[11px] font-black text-title uppercase tracking-widest mb-1">Total à régler</span>
                <div className="text-right">
                  {(() => {
                    const ref = getReferencePrice();
                    const cur = getTotalPrice();
                    return !isFreeOffer && isValidPrice(ref) && cur < ref && (
                      <div className="text-[11px] text-red-500 font-bold line-through opacity-50 mb-1">{ref} DT</div>
                    )
                  })()}
                  <div className="text-3xl font-black tracking-tighter text-primary">{getTotalPrice()} DT</div>
                </div>
              </div>
            </div>
          </div>

          {/* Promo & Payment */}
          <div className="space-y-6">
            <div className="space-y-3">
              <label className="text-[10px] font-black text-title uppercase tracking-widest ml-2">Code Promo (Optionnel)</label>
              <div className="relative">
                <input
                  type="text"
                  value={promoCode}
                  onChange={async e => {
                    const code = e.target.value;
                    setPromoCode(code);
                    if (!code) { setPromoError(""); setDiscountedTotal(null); return; }
                    setPromoLoading(true);
                    try {
                      const res = await validatePromoCodeService(code, offer.id, userData?.id || "", selectedPeriod);
                      const validation = res?.data ?? res;
                      if (validation?.isValid) {
                        const baseTotal = getBaseTotalPrice();
                        const disc = Number(validation.discountPercentage);
                        setDiscountPercent(disc);
                        setDiscountedTotal(Math.max(0, Math.round(baseTotal - (baseTotal * (disc / 100)))));
                        setPromoError("");
                      } else {
                        setPromoError("Code invalide");
                      }
                    } catch {
                      setPromoError("Erreur de verification");
                    } finally { setPromoLoading(false); }
                  }}
                  placeholder="ENTRER LE CODE"
                  className="w-full h-16 px-6 font-black transition-all border-2 outline-none bg-gray-50 border-gray-50 rounded-2xl text-title placeholder:text-text/20 focus:bg-white focus:border-primary/20"
                />
                {promoLoading && <div className="absolute w-6 h-6 border-2 rounded-full right-6 top-5 animate-spin border-primary border-t-transparent"></div>}
              </div>
              {promoError && <p className="text-[10px] font-bold text-red-500 uppercase tracking-widest ml-4">{promoError}</p>}
            </div>

            <div className="space-y-3">
              <label className="text-[10px] font-black text-title uppercase tracking-widest ml-2">Preuve de paiement</label>
              <label className="flex items-center justify-between p-6 transition-all border-2 border-gray-200 border-dashed cursor-pointer bg-gray-50 rounded-2xl hover:border-primary/40 group">
                <div className="flex items-center gap-4">
                  <div className="flex items-center justify-center w-12 h-12 transition-all bg-white shadow-sm rounded-xl text-primary group-hover:scale-110">
                    <UploadFileIcon />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[11px] font-black text-title uppercase tracking-wider">{paymentFile ? "Fichier Reçu" : "Téléverser le reçu"}</span>
                    <span className="text-[9px] font-bold text-text/40 uppercase tracking-widest">{paymentFile ? paymentFile.name : "JPG, PNG ou PDF (MAX 5MB)"}</span>
                  </div>
                </div>
                {!paymentFile && <span className="text-[9px] font-black text-primary uppercase tracking-widest px-4 py-2 bg-white rounded-lg shadow-sm">Choisir</span>}
                <input type="file" onChange={e => setPaymentFile(e.target.files?.[0] || null)} className="hidden" accept="image/*,.pdf" />
              </label>
            </div>
          </div>
        </DialogContent>

        <div className="p-8 pt-0 md:p-12">
          <button
            onClick={async () => {
              if (!paymentFile || submitLoading) return;
              setSubmitLoading(true);
              try {
                const fd = new FormData();
                fd.append("selectedPeriod", selectedPeriod);
                fd.append("requestedSubjectsCount", effectiveSubjectCount.toString());
                if (promoCode) fd.append("promoCode", promoCode);
                fd.append("paymentImage", paymentFile);
                await sendOfferService(offer.id, fd);
                snackbarContext?.showMessage("Succès", "Demande envoyée avec succès", "success");
                handleCloseModal();
                if (onSubscribed) onSubscribed();
              } catch {
                snackbarContext?.showMessage("Erreur", "Fils de l'envoi de la demande", "error");
              } finally { setSubmitLoading(false); }
            }}
            disabled={!paymentFile || submitLoading}
            className={`w-full py-6 rounded-2xl font-black text-[12px] uppercase tracking-[0.4em] shadow-2xl transition-all duration-500 flex items-center justify-center gap-4 ${!paymentFile ? 'bg-gray-200 text-text/20 cursor-not-allowed shadow-none' : 'bg-primary text-white shadow-primary/30 hover:shadow-primary/50 hover:-translate-y-1'}`}
          >
            {submitLoading ? "Envoi en cours..." : "Confirmer l'abonnement"}
            {!submitLoading && <div className="flex items-center justify-center w-6 h-6 text-sm font-normal rounded-lg bg-white/20">✓</div>}
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default OfferCard;




